import { useRef, useEffect, useState } from "react";

const useVideoAutoPlayback = (options = {}, autoPlay = true) => {
    const containerRef = useRef(null);
    const videoRef = useRef<HTMLVideoElement>(null);

    // const [isPlaying, setIsPlaying] = useState(false);

    const cb = (entries: IntersectionObserverEntry[]) => {
        const [entry] = entries;

        if (autoPlay && entry.isIntersecting) {
            videoRef.current?.play();
            // setIsPlaying(true);
        } else {
            videoRef.current?.pause();
            // setIsPlaying(false);
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(cb, options);

        if (containerRef.current) observer.observe(containerRef.current);

        return () => {
            if (containerRef.current) observer.unobserve(containerRef.current);
        };
    }, [containerRef, options]);

    return [containerRef, videoRef /*, isPlaying*/];
};

export { useVideoAutoPlayback };
